<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="title">
              <a-input v-model="model.title" placeholder="请输入标题"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="内容" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="detail">
              <j-editor v-model="model.detail"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="发布人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="releaseName">
              <a-input v-model="model.releaseName" placeholder="请输入发布人"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="当前状态" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="statusing">
              <j-dict-select-tag type="radio" v-model="model.statusing" dictCode="statusing_policy"
                                 placeholder="请选择当前状态"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sorting">
              <a-input-number v-model="model.sorting" placeholder="请输入排序" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="政策分类" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="types">
              <a-select v-model="model.types" placeholder="请选择政策分类">
                <a-select-option v-for="item of policyTypeList" :value="item.id">{{item.name}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="浏览次数" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="browses">
              <a-input-number v-model="model.browses" placeholder="请输入浏览次数" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'BeefPolicyForm',
    components: {},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        model: { statusing: '1' },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          title: [
            { required: true, message: '请输入标题!' }
          ],
          detail: [
            { required: true, message: '请输入内容（html）!' }
          ],
          releaseName: [
            { required: true, message: '请输入发布人!' }
          ],
          statusing: [
            { required: true, message: '请输入当前状态(1.待发布，2.发布，3.下架)!' }
          ],
          types: [
            { required: true, message: '请输入政策分类!' }
          ]
        },
        url: {
          list: '/beef/beefPolicyType/list',
          add: '/beef/beefPolicy/add',
          edit: '/beef/beefPolicy/edit',
          queryById: '/beef/beefPolicy/queryById'
        },
        policyTypeList: []
      }
    },
    computed: {
      formDisabled() {
        return this.disabled
      }
    },
    created() {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
      getAction(this.url.list, { statusing: '1', pageSize: 1000 }).then(res => {
        this.policyTypeList = res.result.records
      })
    },
    methods: {
      add() {
        this.edit(this.modelDefault)
      },
      edit(record) {
        this.model = Object.assign({}, record)
        this.visible = true
      },
      submitForm() {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
            })
          }

        })
      }
    }
  }
</script>